import { RecursoFinanceiro } from 'stores/cifa/cifa.store';

export const formatarValorParaExibicao = (valor: number | string | null | undefined): string => {
    if (!valor && valor !== 0) return '';
    const numeroValor = typeof valor === 'string' ? parseFloat(valor) : valor as number;
    return numeroValor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const processarEntradaValor = (valorString: string): number => {
    const apenasDigitos = valorString.replace(/\D/g, '');
    return apenasDigitos ? parseInt(apenasDigitos, 10) / 100 : 0;
};

export const getRecursoKey = (recurso: RecursoFinanceiro, index: number) => {
    const baseKey = `${recurso.tipo}-${recurso.descricao}`.replace(/\s+/g, '-').toLowerCase();
    return baseKey || `recurso-${index}`;
};

export type ErrorState = {
    [key: string]: {
        tipo?: string;
        descricao?: string;
        valor_orcado?: string;
        valor_liquidado?: string;
    };
};

export const validateRecursos = (itens: RecursoFinanceiro[], rcl: number): { ok: boolean; errors: ErrorState; showEmptyAlert: boolean } => {
    const newErrors: ErrorState = {};
    const descricoes = new Set<string>();
    let isValid = true;

    if (itens.length === 0) {
        return { ok: false, errors: {}, showEmptyAlert: true };
    }

    itens.forEach((item, index) => {
        const itemErrors: Record<string, string> = {};

        if (!item.tipo) itemErrors.tipo = 'Campo obrigatório';
        if (!item.descricao) {
            itemErrors.descricao = 'Campo obrigatório';
        } else if (Array.from(descricoes).some(desc => desc === item.descricao.trim().toLowerCase())) {
            itemErrors.descricao = 'Descrição duplicada';
        } else {
            descricoes.add(item.descricao.trim().toLowerCase());
        }
        if ((item.valor_orcado ?? 0) <= 0) itemErrors.valor_orcado = 'Valor deve ser positivo';
        if ((item.valor_liquidado ?? 0) < 0) itemErrors.valor_liquidado = 'Valor não pode ser negativo';

        if ((item.valor_liquidado ?? 0) > (item.valor_orcado ?? 0)) {
            itemErrors.valor_liquidado = 'Valor liquidado não pode ser maior que o valor orçado';
        }

        if (Object.keys(itemErrors).length > 0) {
            newErrors[index] = itemErrors;
            isValid = false;
        }
    });

    return { ok: isValid, errors: newErrors, showEmptyAlert: false };
};

export const computeResumoFinanceiro = (itens: RecursoFinanceiro[], rcl: number) => {
    const totalOrcado = itens.reduce((acc, item) => acc + (item.valor_orcado || 0), 0);
    const totalLiquidado = itens.reduce((acc, item) => acc + (item.valor_liquidado || 0), 0);
    const percentualExecucao = totalOrcado > 0 ? (totalLiquidado / totalOrcado) * 100 : 0;
    const percentualInvestidoRCL = rcl > 0 ? (totalLiquidado / rcl) * 100 : 0;

    return {
        totalOrcado,
        totalLiquidado,
        percentualExecucao: parseFloat(percentualExecucao.toFixed(2)),
        percentualInvestidoRCL: parseFloat(percentualInvestidoRCL.toFixed(2))
    };
};

export default {};
